<template>
  <!-- Parent has responded -->
  <div class="flex flex-col">
    <Button value="View Conversation" size="medium" class="w-full" :to="viewConversationTo" />
    <div v-if="isInterested">
      <Button value="Mark as not a fit" size="medium" variant="outlined" class="w-full mt-16" @click="moveToNotAFit" />
      <div class="flex mt-16">
        <HelpOutlineIcon class="text-grey-clickable mr-4" :width="24" :height="24" />
        <p class="text-caption mt-2">
          {{ displayName }} will not be notified when marked as "not a fit" and this cannot be undone.
        </p>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import Button from '@/components/button/Button.vue';
import HelpOutlineIcon from '@/graphics/icons/HelpOutlineIcon.vue';
import { Account } from '@/models/account';
import { UPDATE_JOB_APPLICATION_DISMISSAL } from '@/graphql/applications/mutations';

export default {
  name: 'ParentHasReplied',
  components: { Button, HelpOutlineIcon },
  inject: {
    navigateToNextApplication: { default: () => {} },
  },
  computed: {
    sitterUuid(): string | undefined {
      return this.$store.getters['applications/applicationDetails'].sitter?.id;
    },
    viewConversationTo(): string | { path: string; query?: { uuid: string } } {
      if (!this.isPremium) return '/upgrade/pricing';
      return this.sitterUuid ? { path: '/messages', query: { uuid: this.sitterUuid } } : { path: '/messages' };
    },
    isInterested(): boolean {
      return this.$store.getters['applications/applicationDetails'].parentInterestStatus === 'INTERESTED';
    },
    memberCommunicationId(): string {
      return this.$store.getters['applications/applicationDetails'].conversation.memberCommunicationId;
    },
    account(): Account {
      return this.$store.getters['account/getAccount'];
    },
    isPremium(): boolean {
      return !this.account.isBasic();
    },
    displayName(): string {
      return this.$store.getters['applications/applicationDetails'].sitter?.displayName || 'Applicant';
    },
  },
  methods: {
    async moveToNotAFit(): Promise<void> {
      await this.$apollo
        .mutate({
          mutation: UPDATE_JOB_APPLICATION_DISMISSAL,
          variables: {
            applicationUuids: [this.$store.getters['applications/applicationDetails'].id],
            dismiss: true,
          },
        })
        .then(() => {
          this.$store.dispatch('applications/moveAppFromInterestedToNotAFit');
          this.$store.dispatch('applications/showMessageSentNotification', 'Applicant moved to not a fit');
          this.navigateToNextApplication();
        })
        .catch((error: any) => {
          console.error('GraphQL query error:', error);
        });
    },
  },
};
</script>
